// extracted by mini-css-extract-plugin
export var primaryButton = "s8utD";
export var teachingBubble = "IMmbD";